import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import TitleCase from "components/formatting/TitleCase";
import ISONumber from "components/formatting/ISONumber";
import ISOPercentage from "components/formatting/ISOPercentage";
import { Bar } from "components/charting/HorizontalBar";

interface ShareOfVoiceTooltipProps {
  bar: Bar;
}

export default function ShareOfVoiceTooltip(props: ShareOfVoiceTooltipProps): JSX.Element {
  const { i18n } = useTranslation();
  const categoryLabel = props.bar.subCategory_label
    ? `${props.bar.category_label} (${props.bar.subCategory_label})`
    : props.bar.category_label;

  return (
    <Box>
      {/* Title */}
      <Typography sx={{mb: 1}} variant="h4">
        <Box
          sx={{
            width: 14,
            height: 14,
            display:"inline-block",
            mr: 1,
            backgroundColor: props.bar.color,
            borderRadius: "3px"
          }} />
        <TitleCase text={props.bar.label} />
      </Typography>

      {/* Count */}
      <Typography>
        {categoryLabel}:
        <Box sx={{ display:"inline-block", ml: 1 }}>
          <ISONumber number={props.bar.count} sx={{ fontWeight: "bold" }}/>
        </Box>
      </Typography>

      {/* Percentage */}
      <Typography>
        {i18n.t("percent")}:
        <Box sx={{ display:"inline-block", ml: 1 }}>
          <ISOPercentage value={props.bar.percent} sx={{ fontWeight: "bold" }}/>
        </Box>
      </Typography>

      {/* Sum of Queries */}
      {props.bar.value !== undefined &&
        <Typography>
          {i18n.t("widget-types.share-of-voice.tooltip.sum-of-queries")}:
          <Box sx={{ display:"inline-block", ml: 1 }}>
            <ISONumber number={props.bar.value} sx={{ fontWeight: "bold" }}/>
          </Box>
        </Typography>
      }
    </Box>
  );
}
